import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { JourneyName } from './types';

export interface JourneysState {
  journey?: JourneyName,
}

const initialState: Readonly<JourneysState> = {};

export const journeysSlice = createSlice({
  name: 'journeys',
  initialState,
  reducers: {
    setJourney(state: JourneysState, action: PayloadAction<JourneyName>) {
      return {
        ...state,
        journey: action.payload,
      };
    },
  },
});

export const {
  setJourney,
} = journeysSlice.actions;
